import { FC } from "react";

interface IconProps {
  color?: string;
}

const Calendar: FC<IconProps> = ({ color = "#525A6A" }) => (
  <svg
    viewBox="0 0 16 16"
    stroke={color}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2.062 6.27h11.882M10.961 8.873h.006M8.003 8.873h.006M5.038 8.873h.006M10.961 11.464h.006M8.003 11.464h.006M5.038 11.464h.006M10.695 1.333v2.194M5.31 1.333v2.194"
      fill="none"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      clipRule="evenodd"
      d="M10.825 2.386H5.181C3.223 2.386 2 3.476 2 5.481v6.034c0 2.036 1.223 3.152 3.18 3.152h5.64c1.963 0 3.18-1.097 3.18-3.102V5.481c.006-2.004-1.21-3.095-3.175-3.095Z"
      fill="none"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default Calendar;
